module.exports = __webpack_public_path__ + "img/radiance-of-the-seas.0f6ba86a.jpg";